// src/admin/components/BannerContentSection.jsx

import { useTheme } from "../../context/ThemeContext";

export default function BannerContentSection({
    formData,
    updateField,
}) {

    const { isDark } = useTheme();

    const inputClass = `
        w-full
        px-4
        py-3
        rounded-2xl
        border
        outline-none
        transition-all
        ${
            isDark
                ? "bg-white/5 border-white/10 focus:border-blue-700/50"
                : "bg-white border-gray-300 focus:border-blue-700"
        }
    `;

    return (

        <section
            className={`
                rounded-3xl
                border
                p-8
                space-y-6
                ${
                    isDark
                        ? "border-white/10 bg-white/5"
                        : "border-gray-200 bg-white"
                }
            `}
        >

            <div>

                <h2 className="text-xl font-semibold">
                    Banner Content
                </h2>

                <p className="mt-1 text-sm opacity-70">
                    Configure the main content displayed in the advertisement.
                </p>

            </div>

            <div>

                <label className="mb-2 block font-medium">
                    Banner Title
                </label>

                <input
                    type="text"
                    value={formData.title}
                    onChange={(e) =>
                        updateField("title", e.target.value)
                    }
                    placeholder="e.g. Get Started Today"
                    className={inputClass}
                />

            </div>

            <div>

                <label className="mb-2 block font-medium">
                    Banner Message
                </label>

                <textarea
                    rows={5}
                    value={formData.message}
                    onChange={(e) =>
                        updateField("message", e.target.value)
                    }
                    placeholder="Write a compelling message..."
                    className={inputClass}
                />

            </div>

            <div>

                <label className="mb-2 block font-medium">
                    Banner Image
                </label>

                <input
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                        updateField(
                            "image",
                            e.target.files?.[0] || null
                        )
                    }
                    className={`
                        block
                        w-full
                        text-sm
                        ${
                            isDark
                                ? "file:bg-cyan-600 file:text-white"
                                : "file:bg-cyan-500 file:text-white"
                        }
                        file:mr-4
                        file:rounded-lg
                        file:border-0
                        file:px-4
                        file:py-2
                        file:cursor-pointer
                        cursor-pointer
                    `}
                />

                {formData.image && typeof formData.image === "string" && (
                    <div className="mt-4">
                        <img
                            src={formData.image}
                            alt="Current banner"
                            className="
                                h-40
                                rounded-xl
                                border
                                object-cover
                            "
                        />
                    </div>
                )}

            </div>

        </section>

    );

}